<template>
    <div>
        <div class="content-header text-center">
            <h2>{{this.passedData}} Details</h2>
        </div>
        <div class="container-fluid min-content-height">
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Add a Dataset</label>
                        <select class="form-select" v-model="selecteddataset" @change="addDataset">
                            <option value="" disabled selected>Make a selection</option>
                            <option v-for="(item, index) in datasets" :value="item" :key="index">{{item}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Add a Prospect</label>
                        <select class="form-select" v-model="selectedprospect" @change="addProspect">
                            <option value="" disabled selected>Make a selection</option>
                            <option v-for="(item, index) in prospects" :value="item" :key="index">{{item}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <hr>
                    <h3 class="text-center">Datasets</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="btn-group-vertical col-12" v-for='(data, index) in projectdatasets' :key="index">
                    <div class="btn-group mb-2" role="group" aria-label="DatasetExists">
                        <a class="btn col-8 btn-lg btn-primary" @click="$emit('customChangeProject', {shell: 'DataShell', dataset: String(data), project: passedData})"><span class="sidebar-text">{{data}}</span></a>
                        <a class="btn col-2 btn-lg btn-info" @click="$emit('customChangeProject', {shell: 'ReportShell', dataset: String(data), project: passedData})">Reports</a>
                        <a class="btn col-2 btn-lg btn-danger" @click="removeThisDataset(String(data))">Remove</a>
                    </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <hr>
                    <h3 class="text-center">Prospect Lists</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="btn-group-vertical col-12" v-for='(data, index) in projectprospects'>
                    <div class="btn-group mb-2" role="group" aria-label="DatasetExists">
                        <a class="btn col-8 btn-lg btn-primary" v-bind:href="'/generate_download_prospect?prospect='+data+'.csv'"  v-bind:download="data + '.csv'"><span class="sidebar-text">{{data}}</span></a>
                        <a class="btn col-4 btn-lg btn-danger" @click="removeThisDataset(String(data))">Remove</a>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: 'Project Details',
    props: {
        passedData: {
            type: String,
            default() {
                return "Dataset";
            }
        },
        projectrefer: ''
    },
    data(){
        return{
            datasets: [],
            prospects: [],
            projectdatasets: [],
            projectprospects: [],
            selecteddataset: '',
            selectedprospect: ''
        }
    },
     methods: {
        getProjectData() {
            let formData = new FormData();
            formData.append('projectname', this.passedData);
            console.log('project name request test '+this.passedData);
            axios.post('/get_project_data', formData)
                .then(
                (response) => {  
                    var returned = response.data; 
                        for (let i = 0; i < returned.length; i++) {
                            if (returned[i]['name'] === this.passedData) {
                                this.projectdatasets = returned[i]['datasets'];
                                this.projectprospects = returned[i]['prospects'];
                            }
                        }
                })
                .catch(
                (error) => {
                this.errorMessage = error.message;
                console.error("There was an error", error);
            }); 

        },
        getDatasets() {
            axios({
                method : 'POST',
                url : '/list_datasets',
                data:'',
            }).then(
            (response) => {
                this.datasets = processDatasets(response.data);
                this.prospects = processProspects(response.data);
                console.log('test prospect list '+JSON.stringify(this.prospects));
            })
            .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
            });
        },
        addDataset() {
            let formData = new FormData();
            formData.append('projectname', this.passedData);
            formData.append('projectdata', this.selecteddataset);
            axios.post('/update_project_data', formData)
                .then(
                (response) => {  
                    this.getProjectData();
                    this.selecteddataset = '';
                })
                .catch(
                (error) => {
                this.errorMessage = error.message;
                console.error("There was an error", error);
            }); 
        },
        addProspect() {
            let formData = new FormData();
            formData.append('projectname', this.passedData);
            formData.append('projectprosp', this.selectedprospect);
            axios.post('/update_project_data', formData)
                .then(
                (response) => {  
                    this.getProjectData();
                    this.selectedprospect = '';
                })
                .catch(
                (error) => {
                this.errorMessage = error.message;
                console.error("There was an error", error);
            }); 
        },
        removeThisDataset(filename) {
            console.log('preparing to remove dataset '+filename);
            let formData = new FormData();
            formData.append('projectname', this.passedData);
            formData.append('projectdata', filename);
            axios.post('/remove_project_dataset', formData)
            .then(
            (response) => {
                this.getProjectData();
            }).catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error", error);
            });
        }
    },
    mounted() {
        this.getProjectData();
        this.getDatasets();
    }
}
function processDatasets(data) {
      var iH = [];
      var i;
      var b = data;
      for (i = 0; i < b.length; i++) {
        if (b[i].includes('scored-') || b[i].includes('prospect') || b[i].includes('baseline'))
          continue;
            iH.push(b[i]); 
      };
      return iH;
};
function processProspects(data) {
      var iH = [];
      var i;
      var b = data;
      for (i = 0; i < b.length; i++) {
        if (b[i].includes('scored-') || !b[i].includes('prospect'))
          continue;
            iH.push(b[i]);
      };
      return iH;
};
</script>